<template>
  <gj-modal
    :visible.sync="modalVisible"
    size="auto"
    @cancel="cancel"
    @confirm="confirm"
    :confirm-loading="confirmLoading"
    width="600px"
  >
    <template #header>
      <span>快速生成SKU</span>
    </template>
    <template #content>
      <p v-if="form.type == 'single'" class="msg">
        <span>!</span> 快速生成的SKU产品类型均为普通产品，如需关联组合产品，请先在产品资料中维护
      </p>
      <el-form :model="form" ref="form" class="gj-form link-product" label-width="60px">
        <el-form-item prop="type" label="生成方式">
          <el-radio-group v-model="form.type">
            <el-radio label="single">单个SKU</el-radio>
            <el-radio label="multiple">多个SKU</el-radio>
          </el-radio-group>
          <span class="sku-msg" v-if="form.type == 'single'"
            >生成指定SKU， 并将选定的MSKU都关联到该SKU</span
          >
        </el-form-item>

        <template v-if="form.type == 'single'">
          <el-form-item
            prop="sku"
            label="SKU"
            :rules="[{ required: true, message: '请输入SKU', trigger: 'blur' }]"
          >
            <gj-input :width="inputWidth" v-model="form.sku" placeholder="请输入SKU"> </gj-input>
          </el-form-item>
          <el-form-item prop="productName" label="产品名称">
            <gj-input :width="inputWidth" v-model="form.productName" placeholder="请输入产品名称">
            </gj-input>

          </el-form-item>
          <el-form-item prop="categoryId" label="品类">
            <gj-all-category-select
          :multiple="true"
          :width="inputWidth"
          v-model="form.categoryId"
          placeholder="品类"
          :active="false"
        ></gj-all-category-select>
            <i
              class="el-icon-setting"
              style="margin-left: 10px; font-size: 16px"
              v-if="$permission('category:edit')"
              @click="toCategory"
            ></i>
          </el-form-item>
        </template>
        <template v-if="form.type == 'multiple'">
          <p style="font-size: 12px; color: #999999">
            根据MSKU，生成与MSKU编码一致的多个SKU，并将MSKU与SKU一一对应关联
          </p>
        </template>
      </el-form>
    </template>
  </gj-modal>
</template>

<script>
import { modalMixIn, queryMixin } from '@/minxins';
import { batchRelateProduct } from '@/api/sale';

export default {
  name: 'app-relate-product-modal',
  mixins: [modalMixIn, queryMixin],
  props: {
    ids: null,
    commonQueryDTOS:null,
    msku:String,
  },
  created() {
    this.form.sku = this.msku
  },
  data() {
    return {
      inputWidth: '450px',
      form: {
        type: 'single',
        sku: "",
        productName: '',
        categoryId: '',
      },
    };
  },
  methods: {
    toCategory() {
      this.$router.push('/product/product-category');
    },
    confirm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.confirmLoading = true;
          let params = {
            ids: this.ids,
            type: 'quick',
            ...this.form,
            categoryId:Array.isArray(this.form.categoryId) ? this.form.categoryId[0] : '',
                  commonQueryDTOS:this.commonQueryDTOS,
          };
          batchRelateProduct(params)
            .then(() => {
              this.$gjMessage.success('操作成功');
              this.$emit('after');
            })
            .complete(() => (this.confirmLoading = false));
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.link-product{
  /deep/.el-radio__label{
    color: rgba(51, 51, 51, 1) !important;
  }
  /deep/ .el-form-item{
    margin-bottom: 20px;
  }
}
.msg {
  margin-top: 0 !important;
  background: #fff5ed;
  border: 1px solid #f6bb90;
  box-sizing: border-box;
  border-radius: 2px;
  font-size: 12px;
  padding: 10px 0;
  margin-bottom: 20px;
  padding-left: 12px;
  span {
    text-align: center;
    background: #ed6a0c;
    /* padding: 5px; */
    width: 15px;
    height: 15px;
    display: inline-block;
    border-radius: 50%;
    color: white;
    font-weight: 800;
    line-height: 15px;
  }
}
.sku-msg {
  padding-left: 10px;
  font-size: 12px;
  color: #999999;
}
/deep/ .vxe-table--body-wrapper {
  overflow-x: hidden !important;
}
/deep/ .el-dialog__body {
  padding-top: 12px;
}
</style>
